import { resolveByCountry } from '@dc/ui-library/src/helpers/environment';
import { autocompleteLocations } from '@dc/ui-library/src/helpers/location';

import LocationService from '../../../locationservice';
import {
  setSearchingGeolocation,
  setErrorMessage
} from '../../../appState/ducks/listingPageLocationSearch';
import translations from './translations';


export const SuggestionSearchState = Object.freeze({
  SEARCHING: 'SEARCHING',
  LOCATIONS_FOUND: 'LOCATIONS_FOUND',
  LOCATIONS_NOT_FOUND: 'LOCATIONS_NOT_FOUND'
});

export function searchSuggestions(searchTerm, onSuggestionsSearchStateChanged) {
  onSuggestionsSearchStateChanged(SuggestionSearchState.SEARCHING, searchTerm);

  autocompleteLocations(searchTerm, ['(regions)'], resolveByCountry(['uk', 'im'], 'irl'))
    .then(
      (predictions) => {
        onSuggestionsSearchStateChanged(SuggestionSearchState.LOCATIONS_FOUND, searchTerm,
          LocationService.getLocations(
            searchTerm, predictions, LocationService.defaultRestrictions
          ));
      }
    ).catch(
      (e) => {
        if (e === 'ZERO_RESULTS') {
          autocompleteLocations(searchTerm, ['geocode'], resolveByCountry(['uk', 'im'], 'irl'))
            .then(
              (predictions) => {
                onSuggestionsSearchStateChanged(SuggestionSearchState.LOCATIONS_FOUND, searchTerm,
                  LocationService.getLocations(
                    searchTerm, predictions, LocationService.defaultRestrictions
                  ));
              }
            ).catch(
              () => {
                onSuggestionsSearchStateChanged(
                  SuggestionSearchState.LOCATIONS_NOT_FOUND,
                  searchTerm
                );
                console.warn(`NOT FOUND GEOLOCATIONS FOR: ${searchTerm}`);
              }
            );
        }
      }
    );
}

export function setLocation(isAutoSearch, location, page, description) {
  location.source = LocationService.LocationSource.INTERACTIVE;
  location.useCase = {
    page: page,
    description: description
  };

  if (isAutoSearch === true) {
    location.useCase.description = 'autocomplete';
  }

  LocationService.setLocation(location);
}

export function searchCurrentLocationDescriptor() {
  LocationService.searchCurrentLocationDescriptor();
}

export function clearLocation() {
  LocationService.clearLocation();
}


export function setLocationViaGeolocation(page, description) {
  const dispatch = window.appState.dispatch;

  dispatch(setSearchingGeolocation(true));
  LocationService.getGeoLocation()
    .then(
      (location) => {
        dispatch(setSearchingGeolocation(false));
        setLocation(false, location, page, description);
      }
    )
    .catch(
      (error) => {
        dispatch(setSearchingGeolocation(false));
        if (error) {
          dispatch(setErrorMessage(error));
        } else {
          dispatch(setErrorMessage(translations.geolocationGatheringError));
        }
      }
    );
}
